import { ReactNode } from 'react';

export enum SortOrder {
  ASC = 'asc',
  DESC = 'desc'
}

export interface SortableHeaderProps<T> {
  order: SortOrder;
  orderBy: keyof T;
  onRequestSort: (event: React.MouseEvent<unknown>, property: keyof T) => void;
  columns: Column<T>[];
  hasAction?: boolean;
}

export interface Column<T> {
  id: Extract<keyof T, string>;
  label: string;
  options?: {
    align?: 'center' | 'inherit' | 'justify' | 'left' | 'right';
    disablePadding?: boolean;
  };
  format?: (row: T) => ReactNode;
}
